// Cacophony (Uranus): a word with a single vowel scores more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { vowelCount } from '../shared/letters';
import type { AlignmentDef } from '../types';

export const cacophony: AlignmentDef = {
  id: 'cacophony',
  planet: 'uranus',
  name: 'Cacophony',
  text: () => `Words with a single vowel score +${N.cacophonyPercent}%.`,
  wordPercent: (c) => (vowelCount(c.word) === 1 ? N.cacophonyPercent : 0),
};
